export const COMPONENT_DDLB_ON_HANDLE_CHANGE = 'COMPONENT_DDLB_ON_HANDLE_CHANGE'
export const COMPONENT_DDLB_MULTI_ON_HANDLE_CHANGE = 'COMPONENT_DDLB_MULTI_ON_HANDLE_CHANGE'